import React from "react";

// Date: 10 Sep 2026
// Ref: "White screen" reports when switching between CodeNavigator/Continuum
// in an already-used tab. There was no ErrorBoundary anywhere in the tree, so
// any uncaught render/effect error (stale state from a product switch feeding
// a DOM-manipulation effect, etc.) unmounted the entire app with nothing on
// screen. This is a last-resort safety net, not a fix for the underlying
// state bugs (see MainWrapper.js/Home.js) -- it just gives the user a way
// back out instead of a blank tab.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled error caught by ErrorBoundary:", error, info);
  }

  handleReload = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 bg-White p-4 text-center">
          <p className="text-lg font-semibold text-Text">
            Something went wrong.
          </p>
          <button
            onClick={this.handleReload}
            className="rounded-full bg-cfBlue px-5 py-2 text-sm font-semibold text-White"
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
